"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _omit = _interopRequireDefault(require("lodash/omit"));

var _constants = require("../constants");

var _reducers = require("../utils/reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function listenersById() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let {
    type,
    path,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  if (!(payload && payload.name)) return state;

  switch (type) {
    case _constants.actionTypes.SET_LISTENER:
      return { ...state,
        [payload.name]: {
          name: payload.name,
          path
        }
      };

    case _constants.actionTypes.UNSET_LISTENER:
      return (0, _omit.default)(state, [payload.name]);

    default:
      return state;
  }
}

function allListeners() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  if (!(payload && payload.name)) return state;

  switch (type) {
    case _constants.actionTypes.SET_LISTENER:
      return [...state, payload.name];

    case _constants.actionTypes.UNSET_LISTENER:
      return state.filter(name => name !== payload.name);

    default:
      return state;
  }
}

const listenersReducer = (0, _reducers.combineReducers)({
  byId: listenersById,
  allIds: allListeners
});
var _default = listenersReducer;
exports.default = _default;